import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "./CoreComponent";
import { connect } from "react-redux";
import { IGroup } from "../interfaces";
import config from "../config";
import Axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { arrayToFormData } from "../utils/functions";

interface IState {
    groups: IGroup[],
    isLoading: boolean,
}

class Groups extends CoreComponent<any, any> {
    state: IState = {
        groups: [],
        isLoading: true,
    }

    async componentWillMount() {
        this.loadGroups();
    }

    async loadGroups() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/group`;

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    groups: res.data.models,
                    isLoading: false
                });
            }
        });
    }

    async delete(id: number) {
        if (confirm("Вы уверены?")) {
            let response: AxiosResponse = await Axios.post(`${config.api}/group/delete`, arrayToFormData({ id }));

            if (response.data.status == "success") {
                this.setState({
                    groups: this.state.groups.filter((group: IGroup) => group.id != id)
                });

                toast("Группа удалена.", { type: "success" });
            } else {
                toast(response.data.message, { type: "error" });
            }
        }
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-menu">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Группы</span>
                    <div className="crm-holders__buttons">
                        <NavLink className="crm-button" role="button" to="/admin/group">
                            Добавить
                        </NavLink>
                    </div>
                    <div className="crm-menu__items">
                        {this.state.groups.map((group: IGroup, i: number) => {
                            return <div
                                className="crm-menu__item"
                                style={{ marginRight: "20px" }}
                                role="button"
                                key={i}
                            >
                                <NavLink to={"/admin/group/" + group.id}>
                                    <h3 className="cursor-pointer" style={{ color: "#ef225d" }}>{group.name} ({group.holders_count})</h3>
                                </NavLink>

                                <span className="cursor-pointer" style={{ color: "#ef225d" }} onClick={() => {
                                    this.delete(group.id)
                                }}>Удалить</span>
                            </div>;
                        })}

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(Groups));
